import { Typography, Box } from '@mui/material';

const NotAuthorized = (): JSX.Element => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      px: 2,
      textAlign: 'center',
    }}
  >
    <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
      Acceso denegado
    </Typography>

    <Typography variant="body1" sx={{ maxWidth: 380 }}>
      Tu sesión no es válida o ha expirado. Regresa a&nbsp;
      <strong>Helios App</strong> y abre de nuevo el enlace de inspección.
    </Typography>
  </Box>
);

export default NotAuthorized;
